<template>
  <!-- 编辑复制模板弹窗 -->
  <div>
    <el-dialog
      title="编辑复制模板"
      :visible.sync="visible"
      width="710px"
      center
      :before-close="cancel"
      :close-on-click-modal="false">
      <div class="content">
        <div class="y-ml-20 config-box y-pb-15" v-for="item in copyTplSourceData" :key="item.key">
          <p class="config-title y-pd-5 y-p-r y-fl-16 y-fs-14 y-fc-333">{{ item.name }}</p>
          <el-checkbox-group class="y-ml-5" v-model="form[item.key]">
            <el-checkbox v-for="childItem in item.value" :label="childItem.key" :key="childItem.key" :name="item.key">{{ childItem.name }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sure">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import companyList from './expressCompany';
export default {
  props: {
    visible: {
      type: Boolean
    },
    copyTpl: {
      type: Array,
      required: true
    },
    sourcePlat: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: {},
      companyList,
      copyTplSourceData: null
    }
  },
  mounted() {
    let storageCopyInfo = window.localStorage.getItem(`${this.sourcePlat}-copyinfo`);
    if(!storageCopyInfo) {
      // 本地没有存储 复制订单信息的配置，则初始化配置
      window.localStorage.setItem(`${this.sourcePlat}-copyinfo`, JSON.stringify(this.copyTpl))
      this.copyTplSourceData = JSON.parse(JSON.stringify(this.copyTpl));
    } else {
      // 本地有存储了，则覆盖默认的
      this.copyTplSourceData = [
        ...JSON.parse(storageCopyInfo)
      ]
    }
    for(let i = 0, len=this.copyTplSourceData.length; i < len; i++) {
      let checkedArr = [];
      for(let j = 0, jlen = this.copyTplSourceData[i].value.length; j < jlen; j++) {
        if(this.copyTplSourceData[i].value[j].checked) {
          // 选中的情况
          checkedArr.push(this.copyTplSourceData[i].value[j].key);
        }
      }
      this.$set(this.form, this.copyTplSourceData[i].key, checkedArr);
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false);
    },
    sure() {
      let storageCopyTpl = JSON.parse(JSON.stringify(this.copyTplSourceData));
      let hasChecked = false;
      for(let key in this.form) {
          // 说明在当前分类下有选中的需要复制的信息
        if(this.form[key].length > 0)  hasChecked = true;
        // 遍历该信息重新构造 this.copyTplSourceData
        for(let j = 0, len = storageCopyTpl.length; j < len; j++) {
          if(storageCopyTpl[j].key === key) {
            // 相同项
            for(let v = 0, vlen = storageCopyTpl[j].value.length; v < vlen; v++) {
              // 相同项的子项
              if(this.form[key].includes(storageCopyTpl[j].value[v].key)) {
                // 匹配选中的子项，修改 copyTpl中的checked字段为true
                storageCopyTpl[j].value[v].checked = true;
              } else if(storageCopyTpl[j].value[v].checked){
                // 没有匹配上 但是原来的本地存储子项checked是 true 则删除
                delete storageCopyTpl[j].value[v].checked;
              }
            }
          }
        }
      }
      if(!hasChecked) {
        // 没有一个选中项，提示至少选中一个
        this.$message.error('至少需要勾选一个哟～');
        return;
      }
      window.localStorage.setItem(`${this.sourcePlat}-copyinfo`, JSON.stringify(storageCopyTpl));
      this.$message.success('保存复制模板成功');
      this.$emit('update:visible', false);
    },
    editTpl() {
      this.$emit('update:visible', false);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../styles/variables";
.config-box {
  border-bottom: 1px solid #ebeef5;
}
.config-title {
  &:before {
    content: '';
    position: absolute;
    top: 4px;
    left: -5px;
    width: 2px;
    border-radius: 20%;
    background-color: $blue-style;
    height: 18px;
  }
}
</style>